<template>
  <div>
    <p>{{ $t("pages.Auth.Callback.SigninProgress") }}</p>
  </div>
</template>

<script>
export default {
  async created() {
    try {
      var result = await this.$GAUserAuth.signinCallback();
      var returnToUrl = "/";
      if (result.state !== undefined) {
        returnToUrl = result.state;
      }
      this.$router.push({ path: returnToUrl });
    } catch (e) {
      this.$router.push({ name: "Unauthorized" });
    }
  }
};
</script>
